import { computed, onMounted } from "vue"
import { useStore } from "vuex"

export default {
    name: "GruppeadgangsanmodningList",
    props: {
        guid: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            default: 0
        },
        take: {
            type: Number,
            default: 10
        }
    },
    setup(props) { 
        const store = useStore()

        const notifications = computed(() => store.state.search.results[props.guid] ?? [])
        const totalNumberOfNotifications = computed(() => store.state.search.scoped_total[props.guid] ?? 0)
        const showSpinner = computed(() => store.state.search.search_inprogress[props.guid])

        onMounted(() => {
            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.GET_GRUPPEADGANGSANMODNINGER
            })
            
            store.dispatch('search/performSearch', {
                guid: props.guid,
                guery: '',
                skip: props.skip,
                take: props.take
            })
        })

        const getLabel = (labelKey) => 
            store.getters["labels/getLabel"]({
                labelCollection: "gruppeadgangsanmodningList",
                labelKey,
            });

        const getMoreNotifications = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        const rejectGruppeadgangsanmodning = async (gruppeadgangsanmodningId) => {
            store.dispatch('forum/rejectGruppeadgangsanmodning', { gruppeadgangsanmodningId: gruppeadgangsanmodningId})

            const label = getLabel("notificationRejectedLabel")
            await removeNotification(gruppeadgangsanmodningId, label)
        }

        const approveGruppeadgangsanmodning = async (gruppeadgangsanmodningId) => {
            store.dispatch('forum/approveGruppeadgangsanmodning', { gruppeadgangsanmodningId: gruppeadgangsanmodningId})

            const label = getLabel("notificationConfirmedLabel")
            await removeNotification(gruppeadgangsanmodningId, label)
        }

        const removeNotification = async (id, label) => {
            const actionsElementId = getActionsElementId(id)
            const actionsElement = document.getElementById(actionsElementId)
            actionsElement.innerHTML = label

            await new Promise(r => setTimeout(r, 2000))

            updateList()
        }

        const updateList = () => {
            store.dispatch('search/performSearch', {
                guid: props.guid,
                guery: '',
                skip: 0,
                take: notifications.value.length 
            })
        }

        const getActionsElementId = (gruppeadgangsanmodningId) => 'actions-' + gruppeadgangsanmodningId

        return {
            notifications,
            totalNumberOfNotifications,
            showSpinner,
            getActionsElementId,
            getMoreNotifications,
            getLabel,
            rejectGruppeadgangsanmodning,
            approveGruppeadgangsanmodning
        }
    }
}